<template>
  <div class="container">
    <div ref="container" class="map-container"></div>
  </div>
</template>

<script>
import "@tuliu/leaflet/dist/leaflet.css";
import {
  defineComponent,
  ref,
  onMounted,
  watch,
  watchEffect,
  onBeforeUnmount,
} from "@vue/composition-api";
import { BaseMap, ZoomLimit, LayerType } from "@tuliu/base-map";
import L from "@tuliu/leaflet";
import { bus } from "@/utils/bus";
import env from "@/env";

export default defineComponent({
  props: {
    // 地图图层
    layer: {
      type: Number,
      default: LayerType.defaultSatellite,
    },
    // 地图中心点
    center: {
      type: Array,
      default: () => [],
    },
    // 地图缩放层级
    zoom: {
      type: Number,
      default: ZoomLimit.Max,
    },
    // 图形列表
    graphicInfoList: {
      type: Array,
      default: () => [],
    },
    // 只读
    onlyRead: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    "on-mounted",
    "on-map-click",
    "on-polygon-closed",
    "on-polygon-path-chagen",
    "on-graphic-length-or-area-update",
  ],
  setup(props, { emit }) {
    const container = ref(null);
    let baseMap;
    let isInit = false;
    onMounted(() => {
      if (container.value !== null) {
        baseMap = new BaseMap({
          themeColor: "#ff9f00",
          TianDiTuKey: env.TianDiTuKey,
          onlyRead: props.onlyRead,
          container: container.value,
          zoom: props.zoom,
          maxZoom: 18,
          center: props.center,
          poiOptions: {
            container: document.getElementById("poi_box"),
            onPoiChange: (p) => {
              bus.$emit("on-map-click-point", p);
              baseMap.setCenter(p);
            },
          },
          onMounted() {
            isInit = true;
            baseMap?.graphicDiff(props.graphicInfoList);
            emit("on-mounted", baseMap);
          },
          onZoom(zoom, center) {
            emit("on-zoom", zoom, center);
          },
          onMove(center) {
            emit("on-move", center);
          },
          onZoomEnd(zoom) {
            emit("on-zoom-end", zoom);
          },
          onMapClick(point) {
            bus.$emit("on-map-click-point", point);
            emit("on-map-click", point);
          },
          onPolygonClosed(id) {
            emit("on-polygon-closed", id);
          },
          onPolygonPathChange(id, path) {
            emit("on-polygon-path-change", id, path);
          },
          onGraphicLengthOrAreaUpdate(id, length, path) {
            emit("on-graphic-length-or-area-update", id, length, path);
          },
        });
        baseMap.on("map:click", (e) => {
          emit("on-map-click", e);
        });
        baseMap.on("title:click", (e) => {
          emit("on-click", e);
        });
      }
    });

    onBeforeUnmount(() => {
      if (isInit) {
        baseMap.destroy();
      }
    });

    watchEffect(() => {
      const graphicInfoList = props.graphicInfoList;
      if (isInit) {
        baseMap.graphicDiff(graphicInfoList);
      }
    });

    watch(
      () => props.center,
      (center) => {
        if (isInit) {
          baseMap.setCenter(center);
        }
      }
    );

    watchEffect(() => {
      const layer = props.layer;
      if (isInit) {
        baseMap.changeLayerByType(layer);
      }
    });

    watchEffect(() => {
      const zoom = props.zoom;
      if (isInit) {
        baseMap.setZoom(zoom);
      }
    });

    return {
      latLngToLayerPoint: (latLng) => {
        return baseMap.mapInstance.latLngToLayerPoint(latLng);
      },
      latLngToContainerPoint: (latLng) => {
        return baseMap.mapInstance.latLngToContainerPoint(latLng);
      },
      geoJSON: (data) => {
        L.geoJSON(data, {
          style: function () {
            return {
              color: "#70B5FF",
              fill: false,
              dashArray: "1, 1",
              weight: 3,
            };
          },
        })
          .bindPopup(function (layer) {
            return layer.feature.properties.description;
          })
          .addTo(baseMap.mapInstance);
      },
      container,
    };
  },
});
</script>

<style>
.leaflet-control-attribution {
  display: none !important;
}
.icon {
  display: inline-block;
  width: 37px;
  height: 43px;
}
.icon-on,
.icon-off {
  background-size: 37px 43px;
  transition: all 0.3s;
}
.icon-on {
  background-image: url("/images/on-car.png");
}
.icon-on:hover {
  background-image: url("/images/on-car-active.png");
}
.icon-off {
  background-image: url("/images/off-car.png");
}
.icon-off:hover {
  background-image: url("/images/off-car-active.png");
}
</style>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  position: relative;
  .map-container {
    width: 100%;
    height: 100%;
  }
}
</style>
